// 酒店入住
import Log from '../view/log'
import checkInApplication from '../view/hotelCheckIn/checkInApplication/checkInApplication'
import checkInVerification from '../view/hotelCheckIn/checkInVerification/checkInVerification'
import checkInBill from '../view/hotelCheckIn/CheckInBill/checkInBill'
import hotelCheckInNav from '../view/hotelCheckIn/hotelCheckInNav'

export default [
  /* 智慧报修 */
  {
    path: '/check_in_application',
    name: 'check-in-application',
    components: {
      default: hotelCheckInNav,
      a: checkInApplication
    },
  },
  {
    path: '/check_in_verification',
    name: 'check-in-verification',
    components: {
      default: hotelCheckInNav,
      a: checkInVerification
    },
  },
  {
    path: '/check_in_bill',
    name: 'check-in-bill',
    components: {
      default: hotelCheckInNav,
      a: checkInBill
    },
  },
  /* 智慧报修 */
  // 智慧报修操作日志
  {
    path: '/hotel_check_in_log',
    name: 'hotel-check-in-log',
    components: {
      default: hotelCheckInNav,
      a: Log
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/hotelCheckIn.js